export default {
  title: 'Microaudience Projected vs Last Wave Diff (%)',
  infoDialog: 'Trend on estimated KPI contribution by micro audiences (projected vs last period difference)',
  kpi: 'KPI'
}
